<template>

    <div class="modal modal-info fade" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header"
                     v-if="isActionModal"
                >
                    <h4 style="text-align: start">{{title}}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-header" v-else>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="modal-inner">
                        <div class="mb-3">
                            <b>Location</b> <br/>
                            {{shift.client.city?? ''}}, {{shift.client.state?? ''}}
                        </div>
                        <div class="mb-3">
                            <b> Position</b><br/>
                           {{shift.position.title}}
                        </div>
                        <div class="mb-3">
                            <b>Specific hours</b><br/>
                           {{shift.specific_schedule}}
                        </div>
                        <div class="mb-3">
                            <b>Training Information</b><br/>
                            {{shift.training_information}}
                        </div>
                        <div class="mb-3">
                            <b>Pay Range</b><br/>
                           {{shift.pay_range}}
                        </div>
                        <div class="btns-wrap" v-if="isActionModal">
                            <button data-dismiss="modal" class="btn btn--outline-primary">
                                Cancel
                            </button>
                            <button class="btn btn--secondary" @click="confirmation">
                              Proceed
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'EmployeeShiftModal',
        props: {
            title: {
                type: String,
                required: true,
            },
             isActionModal:{
                type: Boolean,
                required: true,
             },
             shift: {
               type: Object,
               required: true,
            },
            modalId: {
                type: String,
                required: true,
            },

        },
        emits: ['confirm'],
        methods: {
            confirmation () {
                $(`#${this.modalId}`).modal('hide');
                this.$emit('confirm', this.shift);
            }
        }
    }
</script>

<style scoped>
</style>
